import { AfterViewInit, Component, effect, Inject, LOCALE_ID } from '@angular/core';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import { VerificationPanelComponent } from "./verification-panel/verification-panel.component";
import { ScreenOrderService } from '../Services/screen-order.service';
import { ElectorDataService, IdvStatus } from '../Services/elector-data.service';
import { MatButtonModule } from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { ApiAboutService } from '../Services/api-about.service';
import { ElectionsPanelComponent } from "./elections-panel/elections-panel.component";
import { PollsPanelComponent } from "./polls-panel/polls-panel.component";
import { PetitionsPanelComponent } from "./petitions-panel/petitions-panel.component";
import { OrganizationsPanelComponent } from './organizations-panel/organizations-panel.component';
import { CommonModule } from '@angular/common';
import { IdUploadService } from '../id-upload/id-upload.service';
import { DecisionDialogService, DialogType } from '../Services/decision-dialog.service';
import { Router } from '@angular/router';
import { changeMfaRoute } from '../route-names';

@Component({
    selector: 'app-dashboard',
    imports: [MatIconModule, MatExpansionModule, OrganizationsPanelComponent, VerificationPanelComponent, MatButtonModule, MatTooltipModule, MatProgressSpinnerModule, ElectionsPanelComponent, PollsPanelComponent, PetitionsPanelComponent, CommonModule],
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements AfterViewInit{
  idVerificationEnabled = true
  statusIDV: IdvStatus = 'NONE';
  dialogTitle?: string;
  dialogText?: string;
  displaySpinner = false
  tooltipText =  $localize`Click to refresh events and ID verification status.`;

  constructor(
    @Inject(LOCALE_ID) readonly locale: string,
    readonly screenService: ScreenOrderService,
    readonly electorDataService: ElectorDataService,
    private readonly aboutService: ApiAboutService,
    private readonly idService: IdUploadService,
    private readonly decisionDialogService: DecisionDialogService,
    private readonly router: Router
  ) {
    effect(() => {
      this.statusIDV = this.electorDataService.idvStatus()
    });
  }

  ngAfterViewInit(): void {
    this.aboutService.headerImageUrl.set(undefined);
    this.aboutService.headerTitle.set("");
    this.aboutService.headerDates.set("");
    if(this.electorDataService.user?.new_user) {
      const dialogRef = this.decisionDialogService.openDialog(
        DialogType.CONFIRM, 
        $localize`Switch authentication method?`,
        $localize`You are currently using email for a second-factor authentication method. Would you like to switch this to use an authenticator app such as DUO or Google Authenticator instead? (This is recommended but not required.)`,
      );
      dialogRef.afterClosed().subscribe((yes) => {
        if (yes) {
          this.router.navigate(changeMfaRoute);
        }
      });

      this.electorDataService.user.new_user = false;
    }
  }
      
  updateDashboard() {
    this.idService.resetIDVFlow();
    this.electorDataService.updateDashboard();  
  } 

  refreshLocked(): boolean {
    return this.electorDataService.isDashBoardUpdateLocked;
  }
}
